// @ts-nocheck
import { ReactNode } from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet';
import { cn } from '@/lib/utils';

type Props = {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
};

export const MobileFormSheet = ({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  className,
}: Props) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className={cn(
          'rounded-t-2xl p-0 flex flex-col max-h-[92vh]',
          className,
        )}
      >
        <div className="px-5 pt-4 pb-3 border-b border-border shrink-0">
          <div className="mx-auto h-1 w-10 rounded-full bg-muted mb-3" />
          <SheetHeader className="text-left">
            <SheetTitle className="text-lg">{title}</SheetTitle>
            {description && (
              <SheetDescription className="text-xs">
                {description}
              </SheetDescription>
            )}
          </SheetHeader>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
        {footer && (
          <div
            className="px-5 py-3 border-t border-border bg-background shrink-0"
            style={{ paddingBottom: 'calc(12px + env(safe-area-inset-bottom))' }}
          >
            {footer}
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
